
import { setInputFilter } from '~/fc/Helpers/DOMHelper'
export default {
    name: 'SliderField',
    components: {
        ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip'),
        slider: () => import(/* webpackChunkName: "Slider" */ '../slider')
    },
    props: ['value', 'field', 'selection'],
    data: () => ({
        sliderOptions: {
            eventType: 'auto',
            width: '100%',
            height: 7,
            dotSize: 20,
            dotHeight: null,
            dotWidth: null,
            show: true,
            speed: 0.5,
            tooltip: false,
            min: 0,
            max: 100,
            interval: 1
        },
        sliderReady: false
    }),
    computed: {
        showAdvancedForm() { return this.$store.state.showAdvancedForm },
        isMobile() { return this.$store.state.store.isMobile },
        isTab() { return process.client ? window.navigator.userAgent.includes('iPad') : false }
    },
    watch: {
        showAdvancedForm() {
            setTimeout(() => {
                this.$refs.slider && this.$refs.slider.refresh()
            }, 300)
        }
    },
    created() {
        if (this.field.customVariables) {
            this.sliderOptions.min = parseInt(this.field.customVariables.min)
            this.sliderOptions.max = parseInt(this.field.customVariables.max)

            if (this.sliderOptions.max > 300) {
                this.sliderOptions.interval = 10
            }
            this.sliderReady = true
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.slider && this.$refs.slider.refresh()
        })
        document.querySelectorAll(`[name="${this.field.name}"]`).forEach((elem) => {
            setInputFilter(elem, null, null, this.field.input_type, false, function(value) {
                return /^-?\d*[.,]?\d*$/.test(value); }, () => {}, () => {})
        })

    },
    methods: {
        takeInput(e) {
            this.$emit('input', e.target.value)
        }
    }
}
